import { Dropdown as Root } from './Dropdown'
import { Content, Item, Label, Portal, Separator, Trigger } from './primitives'

export const Dropdown = {
  Root,
  Content,
  Trigger,
  Portal,
  Item,
  Label,
  Separator
}
